module.exports = {"622926100":"锁南镇","622926101":"达板镇","622926102":"河滩镇","622926103":"那勒寺镇","622926104":"唐汪镇","622926200":"春台乡","622926201":"柳树乡","622926202":"东塬乡","622926204":"坪庄乡","622926205":"百和乡","622926206":"关卜乡","622926208":"赵家乡","622926209":"五家乡","622926210":"果园乡","622926212":"沿岭乡","622926213":"汪集乡","622926214":"风山乡","622926215":"车家湾乡","622926216":"高山乡","622926219":"大树乡","622926220":"北岭乡","622926221":"龙泉乡","622926222":"考勒乡","622926223":"董岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/622926.json
// module id = 2756
// module chunks = 0